export default __webpack_public_path__ + "static/media/gift-banner.f3034b3e.svg";